import { useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useForm } from "@mantine/form";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { Reconciliation } from "../../../api/types";
import useReportReconciliation from "../../../api/useReportReconciliation";
import { typedSxMap } from "../../../utils/typedSxMap";

type ReconciliationModalProps = {
  workspaceId: string;
  reconciliation?: Reconciliation | null;
  message?: string;
  onSuccess: (data: any) => void;
  action: string;
};

const styles = typedSxMap({
  description: {
    // marginBottom: "var(--m-xxxs)",
    color: "var(--color-text-soft)",
  },
  inputContainer: {
    width: "100%",
    marginTop: "-10px",
    paddingBottom: "var(--m-xxs)",
  },
});

export default function ReportReconciliationForm({ workspaceId, reconciliation, message, onSuccess, action }: ReconciliationModalProps) {
  const { mutate, isLoading, error, isSuccess, data } = useReportReconciliation(workspaceId, reconciliation?.id);
  const form = useForm({
    initialValues: {
      id: reconciliation?.id || "",
      message: message || "",
    },
  });

  useEffect(() => {
    if (isSuccess && !error && !isLoading) {
      onSuccess(false);
    }
  }, [isSuccess, error, isLoading]);

  const handleSubmit = async (values: any) => {
    await mutate(values);
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} aria-disabled={isLoading}>
      <Text sx={styles.description}>
        Submitting a report will alert our team to investigate any issues with this reconciliation. Please provide any relevant details below.
      </Text>
      <Box sx={{ ...styles.inputContainer, "& textarea": { minHeight: "120px" } }}>
        <Input as="textarea" name="message" autoComplete="off" placeholder="Describe the issue..." {...form.getInputProps("message")} autoFocus />
      </Box>
      <Button type="submit" variants={["primary", "noMargin"]} disabled={isLoading}>
        {isLoading ? "Please wait..." : "Submit Report"}
      </Button>
    </form>
  );
}
